import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MuiCard(theme: Theme): Components['MuiCard'] {
  return {
    styleOverrides: {
      root: {
        borderRadius: theme.shape.borderRadiusXLarge,
        position: 'relative',
        zIndex: 0, // Fix Safari overflow: hidden with border radius
      },
    },
  };
}
